var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedinHover(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 203,
    height: 144,
    viewBox: "0 0 203 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 59,
    y: 30,
    width: 84,
    height: 84,
    rx: 23.3596,
    fill: "#00ABC5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M130.375 22H72.625C61.2359 22 52 31.2359 52 42.625V100.375C52 111.764 61.2359 121 72.625 121H130.375C141.768 121 151 111.764 151 100.375V42.625C151 31.2359 141.768 22 130.375 22ZM85 100.375H72.625V55H85V100.375ZM78.8125 49.7695C74.8277 49.7695 71.5938 46.5107 71.5938 42.493C71.5938 38.4752 74.8277 35.2165 78.8125 35.2165C82.7973 35.2165 86.0312 38.4752 86.0312 42.493C86.0312 46.5107 82.8014 49.7695 78.8125 49.7695ZM134.5 100.375H122.125V77.2585C122.125 63.3655 105.625 64.4174 105.625 77.2585V100.375H93.25V55H105.625V62.2806C111.384 51.6134 134.5 50.8255 134.5 72.4941V100.375Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinHover);
export default __webpack_public_path__ + "static/media/LinkedinHover.98a55c67d2ab920c0397ad5d1a2bb5a5.svg";
export { ForwardRef as ReactComponent };